export default {
  id: 186,
  title: 'Target #186 - Guernsey',
  url: 'https://cssbattle.dev/play/186',
  colors: ['#F9DD16', '#E8112D', '#FFFFFF'],
  solution:
    '<p c><p d><p a><p b><style>body{background:linear-gradient(transparent 110px,#e8112d 110px 190px,transparent 190px),linear-gradient(90deg,transparent 160px,#e8112d 160px 240px,transparent 240px)}p{position:fixed}p[a],p[b],p[c],p[d]{width:200;height:20}p[a],p[b]{top:114;left:85;border-width:10 15;border-style:solid;border-color:transparent #f9dd16}p[c],p[d]{top:124;left:100;background:#f9dd16}p[b],p[d]{transform-origin:center;transform:rotate(90deg)}</style>',
}
